import { render, staticRenderFns } from "./quickInfo.vue?vue&type=template&id=e62b0f4c&"
import script from "./quickInfo.vue?vue&type=script&lang=js&"
export * from "./quickInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports